import PropTypes from 'prop-types';
import React from 'react';
import { noop } from 'lodash';
import { InputNumber } from '@sm360/widget-commons-forms';
import { LocaleService } from '@sm360/widget-commons-core-services';

import 'commons-vehicle/Vehicle/components/PaymentOptionFilters/PaymentRange/PaymentRange.scss';

// eslint-disable-next-line no-unused-vars
const PaymentRange = ({ initialTargetPayment, paymentRangeBoundaries, setTargetPayment, onChange, disabled }) => {
    const step = paymentRangeBoundaries[1] === 2000 ? 25 : paymentRangeBoundaries[1] / 100;
    const handleChange = (value) => {
        const parsedValue = value > 0 ? parseFloat(value) : 5;
        // setTargetPayment(parsedValue);
        onChange(String(parsedValue));
    };
    return (
        <div className="listing-used-desired-payment target-payment">
            <InputNumber
                min={paymentRangeBoundaries[0]}
                max={paymentRangeBoundaries[1]}
                step={step}
                decimalCount={2}
                value={Number.parseFloat(initialTargetPayment).toFixed(2)}
                onChange={handleChange}
                label={LocaleService.t('FILTERS.INITIAL_PAYMENT')}
                showLabel
                lightTheme
                disabled={disabled}
            />
        </div>
    );
};

PaymentRange.defaultProps = {
    onChange: noop,
    disabled: false,
};

PaymentRange.propTypes = {
    initialTargetPayment: PropTypes.number.isRequired,
    paymentRangeBoundaries: PropTypes.arrayOf(PropTypes.number),
    setTargetPayment: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
};

PaymentRange.displayName = 'PaymentRange';

export default PaymentRange;
